import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ResetPasswordForm() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [captchaQuestion, setCaptchaQuestion] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/captcha')
      .then(res => res.json())
      .then(data => {
        setCaptchaQuestion(data.question);
        setCaptchaToken(data.token);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    const res = await fetch('/api/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, newPassword, captchaAnswer, captchaToken })
    });
    const data = await res.json();
    setMessage(data.message || data.error);
    if (res.ok) setTimeout(() => navigate('/login'), 2500);
  };

  return (
    <div className="login-form" style={{ maxWidth: 400, margin: '2rem auto' }}>
      <h1>Passwort zurücksetzen</h1>
      {message && <div style={{ marginBottom: 20, color: '#d8000c' }}>{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Neues Passwort</label>
          <input type="password" required value={newPassword} onChange={e => setNewPassword(e.target.value)} />
        </div>
        {captchaQuestion && (
          <div className="form-group">
            <label>{captchaQuestion}</label>
            <input type="text" required value={captchaAnswer} onChange={e => setCaptchaAnswer(e.target.value)} />
          </div>
        )}
        <button type="submit" className="btn-submit">Passwort setzen</button>
      </form>
    </div>
  );
}
